module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v(_vm._s(_vm.placeHold))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.vali),
      expression: "vali"
    }, {
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "topcoat-text-input",
    class: {
      'is-danger': _vm.errors.has('text')
    },
    attrs: {
      "type": "text",
      "data-vv-name": "text",
      "placeholder": _vm.placeHold
    },
    domProps: {
      "value": _vm._s(_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('text')),
      expression: "errors.has('text')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("X")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-590dacd3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextInput.vue
// module id = 114
// module chunks = 2